
export class RequestBase {

  handshake?: string | null;
  applicationId?: string | null;
  moduleId?: string | null;
  processFilter?: number | null;
}

export class RequestBaseIds<T> extends RequestBase {

  ids?: T[] | null;
}

export abstract class RequestBasePage extends RequestBase {

  skip?: number | null;
  take?: number | null;
  page?: number | null;
  pagesize?: number | null;
  sort?: string | null;
  group?: string | null;
  filter?: string | null;

}

/* TODO - update code to use collection version, will be relegated*/
export class RequestBasePageId extends RequestBasePage {

  id?: string | null;
}

/* TODO - update code to use collection version, will be relegated*/
export class RequestBasePageCode extends RequestBasePage {

  code?: string | null;
}

export class RequestBasePageIds extends RequestBasePage {

  ids?: string[] | null;
}

export class RequestBasePageCodes extends RequestBasePage {

  codes?: string[] | null;
}

export class RequestBaseSet<T> extends RequestBase {

  data?: T[] | null;
}
